import { render, staticRenderFns } from "./SupervisorSignature.vue?vue&type=template&id=2cf45c2c&"
import script from "./SupervisorSignature.vue?vue&type=script&lang=js&"
export * from "./SupervisorSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports